import React from 'react'

import { TitleBlock } from './styled'
import { ITitleProps } from './types'

/**
 * Title for pages
 */
export const Title = React.forwardRef((props: ITitleProps = { text: '' }, ref: any) => (
  <TitleBlock {...props} ref={ref}>
    {props.text}
    {props.children ? props.children : null}
  </TitleBlock>
))

Title.defaultProps = {
  text: '',
}

export default Title
